"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureFieldBuilder = exports.DynamicOptionFieldBuilder = exports.OptionFieldBuilder = exports.MoneyFieldBuilder = exports.ButtonFieldBuilder = exports.InformationFieldBuilder = exports.PhoneFieldBuilder = exports.NumberFieldBuilder = exports.ConsentFieldBuilder = exports.YearMonthFieldBuilder = exports.DateFieldBuilder = exports.TextFieldBuilder = void 0;
const lodash_1 = __importDefault(require("lodash"));
const fieldTypes_1 = require("../../../types/carrierQuestionnaire/fieldTypes");
const structureValidations_1 = require("../../structureValidations");
const validations_1 = require("../../validations");
const NodeBuilder_1 = __importDefault(require("./NodeBuilder"));
class FieldBuilder extends NodeBuilder_1.default {
    constructor(nodeSeed) {
        super(nodeSeed);
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    withId(id) {
        this.node.id = id;
        return this.clone();
    }
    withNodeId(nodeId) {
        this.node.nodeId = nodeId;
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    withEffects(effects) {
        this.node.effects = effects;
        return this.clone();
    }
    makeDisabled() {
        this.node.disabled = true;
        return this.clone();
    }
    makeEncrypted() {
        this.node.encrypted = true;
        return this.clone();
    }
    makePhi() {
        this.node.PHI = true;
        return this.clone();
    }
    withDefaultValue(defaultValue) {
        this.node.defaultValue = defaultValue;
        return this.clone();
    }
    visibleIf(condition) {
        this.node.visibleIf = condition;
        return this.clone();
    }
    validate(field) {
        return (0, structureValidations_1.validateField)(field);
    }
}
exports.default = FieldBuilder;
class TextFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.input,
            validation: { type: validations_1.Validations.string },
        });
        super(seed);
    }
}
exports.TextFieldBuilder = TextFieldBuilder;
class DateFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.date,
            validation: validations_1.Validations.date,
        });
        super(seed);
    }
}
exports.DateFieldBuilder = DateFieldBuilder;
class YearMonthFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.yearMonth,
            validation: validations_1.Validations.yearMonth,
        });
        super(seed);
    }
}
exports.YearMonthFieldBuilder = YearMonthFieldBuilder;
// TODO @QuestionnaireBuilder : Should this be an AgreeField type?
class ConsentFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.agree,
            validation: { type: validations_1.Validations.booleanTrue },
        });
        super(seed);
    }
}
exports.ConsentFieldBuilder = ConsentFieldBuilder;
class NumberFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.number,
            validation: { type: validations_1.Validations.integer },
        });
        super(seed);
    }
}
exports.NumberFieldBuilder = NumberFieldBuilder;
class PhoneFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.phone,
            validation: { type: validations_1.Validations.phoneNumber },
        });
        super(seed);
    }
}
exports.PhoneFieldBuilder = PhoneFieldBuilder;
class InformationFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.information,
        });
        super(seed);
    }
}
exports.InformationFieldBuilder = InformationFieldBuilder;
class ButtonFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.button,
        });
        super(seed);
    }
}
exports.ButtonFieldBuilder = ButtonFieldBuilder;
class MoneyFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        const seed = Object.assign(seedProviders.forInputField(), {
            type: fieldTypes_1.FieldTypes.money,
            validation: { type: validations_1.Validations.integer },
        });
        super(seed);
    }
}
exports.MoneyFieldBuilder = MoneyFieldBuilder;
class OptionFieldBuilder extends FieldBuilder {
    constructor(seedProviders) {
        super(seedProviders.forOptionField());
    }
    withOptions(options) {
        this.node.options = options;
        return this.clone();
    }
    withType(type) {
        this.node.type = type;
        return this.clone();
    }
}
exports.OptionFieldBuilder = OptionFieldBuilder;
class DynamicOptionFieldBuilder extends FieldBuilder {
    constructor(seedProviders, dynamicOptions) {
        super(seedProviders.forDynamicOptionField(dynamicOptions));
    }
    withOptions(options) {
        this.node.options = options;
        return this.clone();
    }
    withType(type) {
        this.node.type = type;
        return lodash_1.default.cloneDeep(this);
    }
}
exports.DynamicOptionFieldBuilder = DynamicOptionFieldBuilder;
class SignatureFieldBuilder extends FieldBuilder {
    constructor(seedProviders, participantRole) {
        super(seedProviders.forSignatureField(participantRole));
    }
}
exports.SignatureFieldBuilder = SignatureFieldBuilder;
